import { createContext, useContext } from 'react';

export type SidekickChat = {
  chatId: string;
  startNewChat: () => void;
  selectChat: (chatId: string) => void;
};

const SidekickChatContext = createContext<SidekickChat | null>(null);

export const SidekickChatProvider = SidekickChatContext.Provider;

/** Reads the active chat session and the ways to switch it. */
export const useSidekickChat = (): SidekickChat => {
  const context = useContext(SidekickChatContext);
  if (!context) {
    throw new Error(
      'useSidekickChat must be used within a SidekickChatProvider',
    );
  }
  return context;
};
